import classNames from 'classnames';
import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { Avatar } from '@gem/call/Removable/components/Avatar/Avatar';
import { AvatarTypes } from '@gem/call/Removable/components/Avatar/Avatar';
import { popupItemStyles } from '@gem/ui-kit';

import { useCallMemberPermissionsItemPresenter } from './CallMemberPermissionsItem.presenter';
import styles from './CallMemberPermissionsItem.styles.m.css';
import { ICallMemberPermissionsItemProps } from './CallMemberPermissionsItem.types';

export const CallMemberPermissionsItem: FC<ICallMemberPermissionsItemProps> = observer((props) => {
  const presenter = useCallMemberPermissionsItemPresenter(props);

  return (
    <button
      tabIndex={0}
      onClick={presenter.onMemberClick}
      className={classNames(styles.container, popupItemStyles.interactive)}
    >
      <Avatar
        type={AvatarTypes.Round_10}
        title={presenter.member?.displayName}
        url={presenter.member?.avatarUrl}
      />
      <div className={styles.memberInfo}>
        <div className={styles.memberName}>{presenter.member?.displayName}</div>
        <div className={styles.memberPermissions}>{presenter.permissionsTranslations}</div>
      </div>
    </button>
  );
});
